import React, { useState, useEffect } from 'react';
import { Nav, Container, Row, Col, Form, Button, Card, ListGroup } from 'react-bootstrap';
import { useMutation } from '@apollo/client';
import { Link } from 'react-router-dom';
import { CREATE_MODULE, GET_ALL_MODULES } from '../../../gql/admin/modules/mutation';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from 'react-bootstrap';
import Loaders from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

function Modules() {

    const [moduleName, setModuleName] = useState('');
    const permissionTemplate = { permissionName: '' }
    const [permissions, setPermissions] = useState([permissionTemplate])
    const [errorMessage, setErrorMessage] = useState('')
    const [createSuccess, setCreateSuccess] = useState(false)
    const [created, setCreated] = useState(false)
    const [allModules, setAllModules] = useState('')
    const [createModule, { loading }] = useMutation(CREATE_MODULE, {
        onCompleted(data) {
            setCreated(true)
            setCreateSuccess(true)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
    })

    const [getAllModules, { loading: getLoading }] = useMutation(GET_ALL_MODULES, {
        onCompleted(data) {
            setAllModules(data?.getAllModules)
        },
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        },
        fetchPolicy: 'network-only',

    })

    useEffect(() => {
        getAllModules()

        //eslint-disable-next-line
    }, [created])

    const handleChange = (e, index) => {
        const updatePermission = permissions.map((permission, i) => index === i ? Object.assign(permission, { [e.target.name]: e.target.value }) : permission)
        setPermissions(updatePermission)
    }

    const handleClick = () => {
        setPermissions([...permissions, permissionTemplate])
    }

    const removePermission = (i) => {
        const filteredPermission = [...permissions]
        filteredPermission.splice(i, 1)
        setPermissions(filteredPermission)

    }

    const handleSave = () => {
        let sendArray = []
        permissions.map((item) => (
            sendArray.push(item.permissionName)
        ))

        // let sendData = {
        //     // permissions : permissions,
        //     permissions : sendArray,
        //     moduleName: moduleName
        // }

        if (moduleName && permissions.length > 0) {
            createModule({
                variables: {
                    createModulesInput: {
                        moduleName: moduleName,
                        permissions: sendArray
                    }
                }
            })
        }
        else {
            toast.error("Please Fill The Fields", {
                position: "bottom-right",
            })
        }

        // console.log("sendData >>> ", sendData)

    }

    if (errorMessage) {
        toast.error(errorMessage, {
            position: "bottom-right",
        })
        setErrorMessage('')
    }

    if (createSuccess) {
        toast.success("Saved Successfully.", {
            position: "bottom-right",
        });
        setModuleName('')
        setPermissions([permissionTemplate])
        setCreateSuccess(false);
    }

    if(getLoading){
        return  <div className="spinner" >
        <Loaders
            type="ThreeDots"
            color="#192f60"
            height={70}
            width={70}
            timeout={3000}
        />
    </div>
    }

    const displayPermissions = (pdata) => {
        try {
            if (pdata && pdata.length > 0) {
                return pdata.map((item, i) => (
                    <ListGroup.Item key={i} >{item}</ListGroup.Item>
                ))
            }
        }
        catch (error) {
            console.log(error)
        }
    }


    return (
        <div>
            <h1 className='page-title'>Admin Settings</h1>
            <Nav
                className='setting-menu'
            >
                <Nav.Item>
                    <Link to="/admin-settings/modules" className='nav-link active'>Modules</Link>
                </Nav.Item>
                <Nav.Item>
                    <Link to="/admin-settings/permissions" className='nav-link'>Permissions</Link>
                </Nav.Item>
                <Nav.Item>
                    <Link to="/admin-settings/roles" className='nav-link'>Roles</Link>
                </Nav.Item>
            </Nav>
            <div className='profile-sec'>
                <div style={{ display: 'flex' }} >
                    <div>
                        <div>
                            <Container>
                                <Row>
                                    <Col>
                                        <Form.Group controlId="moduleName">
                                            <Form.Label>Module Name</Form.Label>
                                            <Form.Control
                                                name="moduleName"
                                                type="text"
                                                placeholder="Enter Module Name Eg: user-module"
                                                value={moduleName}
                                                onChange={(e) => setModuleName(e.target.value)}
                                                style={{ width: '542px' }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Container>
                        </div>

                        <div>
                            <Container>
                                {
                                    permissions.map((permission, i) => (
                                        <Row key={i} style={{ marginTop: '10px', marginBottom: '10px' }} >
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Permission Name</Form.Label>
                                                    <Form.Control
                                                        name="permissionName"
                                                        type="text"
                                                        placeholder="Enter Permission Name Eg: updateProfile"
                                                        value={permission.permissionName}
                                                        onChange={(e) => handleChange(e, i)}
                                                        style={{ width: '542px' }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Button onClick={() => removePermission(i)} style={{ marginTop: '34px' }} >Delete</Button>
                                            </Col>
                                        </Row>
                                    ))
                                }
                            </Container>
                        </div>

                        <div>
                            <Button onClick={handleClick} style={{ marginTop: '10px', marginBottom: '10px' }} >Add More Permission</Button>
                        </div>

                        <div>
                            {
                                loading ?
                                    <Button style={{ marginTop: '20px', marginBottom: '10px', width: '130px' }} >Save
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    </Button>
                                    :
                                    <Button onClick={handleSave} style={{ marginTop: '20px', marginBottom: '10px', width: '130px' }} >Save</Button>
                            }
                        </div>
                    </div>

                    <div>
                        <Container>
                            <Row>
                                <Col style={{ marginLeft: '119px' }} >
                                    <div>
                                        {
                                            allModules && allModules.length > 0 && allModules.map((item) => (
                                                <Card style={{ width: '18rem', marginBottom: '15px' }} key={item?.id} >
                                                    <Card.Header>{item?.moduleName}</Card.Header>
                                                    <ListGroup variant="flush">
                                                        {displayPermissions(item?.permissions)}
                                                    </ListGroup>
                                                </Card>
                                            ))
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default Modules